import { gql } from '@apollo/client';

export const LABEL_FIELDS = gql`
  fragment LabelFields on Label {
    id
    labelId
    labelGroupId
    partnerId
    displayName
    isPublic
    updatedAt
  }
`;
